import { useEffect, useState } from "react"
import { getPresupuestoHistorico } from "../../../api/presupuesto"
import IPresupuestoHistorico from "../../../interfaces/PresupuestoHistorico"
import { useTranslation } from "react-i18next"
import SplineChart from "../../../components/Charts/SplineChart"
import { CardLoader } from "../Loaders/DataSectionLoader"
import { ChartContainerLoader } from "../../../components/Generic/Charts"

const PresupuestoAsignadoEjecutado: React.FC<{ code?: string, mode: "asignado" | "ejecutado" }> = ({ code, mode }) => {

    const { t } = useTranslation("translation", { keyPrefix: "asignado_ejecutado_charts" });

    const [data, setData] = useState<number[]>();
    const [categories, setCategories] = useState<string[]>();

    const mapData = (presupuesto: IPresupuestoHistorico[]) => {
        var localData: number[] = [];
        var localCategories: string[] = [];
        presupuesto!.forEach((element: IPresupuestoHistorico) => {
            if (mode === "asignado") {
                localData.push(element.presupuestoAsignado);
            } else {
                localData.push(element.ejecutado);
            }

            localCategories.push(`${element.periodo}`);
        });
        setData(localData);
        setCategories(localCategories);
    }

    useEffect(() => {
        getPresupuestoHistorico(code)
            .then((res) => {
                mapData(res)
            }, (reason) => {
                //No hay datos entonces logueo a la consola
                console.log(reason)
            })

        return () => {
            // cleanup
            setData(undefined)
            setCategories(undefined)
        }
    }, [code, mode])

    if(!data) {
        return <ChartContainerLoader colSize="12" />;
    }

    return (
        <div className="card" id="presupuesto-asignado-ejecutado">
            <div className="card-body">
                <SplineChart
                    chartName={mode==="asignado" ? t("asignado") : t("ejecutado")}
                    data={data!}
                    categories={categories!}
                    yAxisTitle={t("dollar")}
                />
            </div>
        </div>

    )
}

export default PresupuestoAsignadoEjecutado